import { render, staticRenderFns } from "./ShareClassListGroupItem.vue?vue&type=template&id=2784ec26&"
import script from "./ShareClassListGroupItem.vue?vue&type=script&lang=js&"
export * from "./ShareClassListGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports